// /app/hook/useEnterKey.ts
import { useEffect } from 'react';

const useEnterKey = (handleSearch: () => void, isSearchActive: boolean) => {
  useEffect(() => {
    if (isSearchActive) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
          handleSearch(); // Trigger the search when Enter is pressed
        }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [handleSearch, isSearchActive]);
};

export default useEnterKey;
